import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, FileTextIcon, HeartIcon } from 'lucide-react';
const threats = [{
  icon: AlertTriangleIcon,
  title: 'Digital Blackout',
  description: 'When the grid fails, your phone becomes a paperweight. No cloud. No passwords. No access to critical family data.'
}, {
  icon: FileTextIcon,
  title: 'Bureaucratic Nightmare',
  description: 'Without physical documentation, insurance claims stall, medical care gets delayed, and legal processes grind to a halt.'
}, {
  icon: HeartIcon,
  title: 'Family Vulnerability',
  description: "Your children's medical histories, allergies, and emergency contacts — all trapped in devices that won't turn on."
}];
export function PainPointSection() {
  return <section className="bg-light-gray py-20 px-4 border-b border-gray-200" data-id="element-90">
      <div className="max-w-7xl mx-auto" data-id="element-91">
        <div className="text-center mb-12" data-id="element-92">
          <span className="font-heading text-sm font-bold text-safety-red tracking-[0.2em] uppercase mb-2 block" data-id="element-93">
            Threat Assessment
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy" data-id="element-94">
            The Threat Is Real
          </h2>
          <div className="w-24 h-1 bg-navy mx-auto mt-6" data-id="element-95"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-96">
          {threats.map((threat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 border border-gray-300 shadow-document relative" data-id="element-97">
              {/* Official card header styling */}
              <div className="absolute top-0 left-0 w-full h-1 bg-navy" data-id="element-98"></div>

              <div className="w-14 h-14 rounded-full bg-red-50 border border-red-100 flex items-center justify-center mb-6" data-id="element-99">
                <threat.icon className="w-7 h-7 text-safety-red" data-id="element-100" />
              </div>

              <h3 className="font-heading font-bold text-xl text-navy mb-4 uppercase tracking-wide" data-id="element-101">
                {threat.title}
              </h3>

              <p className="font-body text-gray-700 leading-relaxed" data-id="element-102">
                {threat.description}
              </p>

              <div className="mt-6 pt-4 border-t border-gray-100 flex justify-between items-center" data-id="element-103">
                <span className="font-heading text-[10px] text-gray-400 uppercase tracking-widest" data-id="element-104">
                  Status: Critical
                </span>
                <span className="font-heading text-[10px] text-gray-400 uppercase tracking-widest" data-id="element-105">
                  Ref: {String(index + 1).padStart(3, '0')}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}